import json from './config/feedback-config.json';

export const config = json;
export * from './actions/feedback-actions';
export * from './actions/feedback-form-actions';
export * from './stores/feedback-store';
export * from './stores/feedback-store-actions';
